import { useCallback, useEffect, useRef } from 'react'
import { reduce } from '../functions/reduce'
import { useZoomsForCache } from './useZoomsForCache'

interface Props {
  maxCachedReducedData: Float32Array
  zoomStep: number
  canvasWidth: number
}

export function useGetCachedReducedData({ maxCachedReducedData, zoomStep, canvasWidth }: Props) {
  const cachedZooms = useZoomsForCache({ zoomStep, maxLength: maxCachedReducedData.length })
  const dataCache = useRef<Map<number, Float32Array>>(new Map())

  useEffect(() => {
    dataCache.current.clear()
  }, [maxCachedReducedData])

  return useCallback(
    (zoom: number): Float32Array | undefined => {
      if (!cachedZooms.includes(zoom)) {
        return
      }
      if (!dataCache.current.has(zoom)) {
        const maxScale = cachedZooms[cachedZooms.length - 1]
        for (let i = maxScale; i >= zoom; i /= zoomStep) {
          const source = i === maxScale ? maxCachedReducedData : dataCache.current.get(i * zoomStep)
          if (source) {
            dataCache.current.set(i, reduce(source, canvasWidth * i))
          }
        }
      }
      return dataCache.current.get(zoom)
    },
    [cachedZooms, maxCachedReducedData, zoomStep, canvasWidth],
  )
}
